import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft } from 'lucide-react';

import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{paddingTop:'7rem',paddingBottom:'5rem',backgroundColor:'white',minHeight:'100vh'}}>
      <Helmet>
        <title>Kebijakan Privasi - Lakpesdam PBNU</title>
        <meta name="description" content="Kebijakan privasi dan pengumpulan data pengunjung website Lakpesdam PBNU." />
        <meta property="og:title" content="Kebijakan Privasi - Lakpesdam PBNU" />
        <meta property="og:description" content="Kebijakan privasi dan pengumpulan data pengunjung website Lakpesdam PBNU." />
        <meta property="og:image" content="https://lakpesdam.or.id/assets/og-image.png" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div style={{width:'100%',maxWidth:'800px',margin:'0 auto',paddingLeft:'1.5rem',paddingRight:'1.5rem'}}>
        <button onClick={() => navigate(-1)} style={{display:'flex',alignItems:'center',gap:'0.5rem',fontWeight:600,color:'#475569',marginBottom:'2rem',background:'none',border:'none',cursor:'pointer'}}>
          <ArrowLeft size={20} /> Kembali ke Beranda
        </button>

        <h1 style={{fontSize:'2rem',fontWeight:800,color:'#0f172a',marginBottom:'2rem',lineHeight:1.3}}>Kebijakan Privasi</h1>
        <p style={{color:'#64748b',fontSize:'0.875rem',marginBottom:'2rem'}}>Terakhir diperbarui: 6 Juni 2026</p>

        <div style={{color:'#334155',fontSize:'1.0625rem',lineHeight:1.8}}>
          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>1. Pengantar</h2>
            <p>Lakpesdam PBNU ("kami") menghargai privasi pengunjung website ini. Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda saat mengakses website kami di <strong>lakpesdam.or.id</strong>.</p>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>2. Informasi yang Kami Kumpulkan</h2>
            <p style={{marginBottom:'0.75rem'}}>Kami mengumpulkan informasi berikut secara otomatis:</p>
            <ul style={{paddingLeft:'1.5rem',marginBottom:'0.75rem'}}>
              <li style={{marginBottom:'0.5rem'}}><strong>Data Kunjungan:</strong> Jumlah kunjungan halaman, tanggal dan waktu akses, durasi kunjungan</li>
              <li style={{marginBottom:'0.5rem'}}><strong>Lokasi Umum:</strong> Kota dan negara pengunjung (berdasarkan alamat IP, tidak lebih spesifik)</li>
              <li style={{marginBottom:'0.5rem'}}><strong>Jenis Peramban:</strong> Informasi umum tentang browser dan perangkat yang digunakan</li>
            </ul>
            <p>Kami <strong>TIDAK</strong> mengumpulkan nama, alamat email, nomor telepon, atau informasi pribadi lainnya dari pengunjung umum.</p>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>3. Penggunaan Cookies</h2>
            <p style={{marginBottom:'0.75rem'}}>Website ini menggunakan cookies untuk:</p>
            <ul style={{paddingLeft:'1.5rem',marginBottom:'0.75rem'}}>
              <li style={{marginBottom:'0.5rem'}}><strong>Google Translate:</strong> Menyimpan preferensi bahasa pilihan Anda</li>
              <li style={{marginBottom:'0.5rem'}}><strong>Sesi Login Kontributor:</strong> Menyimpan token autentikasi untuk panel kontributor</li>
            </ul>
            <p>Anda dapat mengatur browser Anda untuk menolak cookies, namun beberapa fitur mungkin tidak berfungsi dengan baik.</p>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>4. Layanan Pihak Ketiga</h2>
            <p style={{marginBottom:'0.75rem'}}>Website kami menggunakan layanan pihak ketiga berikut yang memiliki kebijakan privasi mereka sendiri:</p>
            <ul style={{paddingLeft:'1.5rem',marginBottom:'0.75rem'}}>
              <li style={{marginBottom:'0.5rem'}}><strong>Google Translate:</strong> Untuk fitur terjemahan halaman</li>
              <li style={{marginBottom:'0.5rem'}}><strong>YouTube:</strong> Untuk menampilkan video dari kanal YouTube kami</li>
              <li style={{marginBottom:'0.5rem'}}><strong>WordPress:</strong> Sebagai sistem manajemen konten backend</li>
            </ul>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>5. Keamanan Data</h2>
            <p>Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi data yang dikumpulkan. Namun, tidak ada metode transmisi internet atau penyimpanan elektronik yang 100% aman. Kami tidak dapat menjamin keamanan absolut data Anda.</p>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>6. Hak Anda</h2>
            <p>Anda memiliki hak untuk:</p>
            <ul style={{paddingLeft:'1.5rem',marginBottom:'0.75rem'}}>
              <li style={{marginBottom:'0.5rem'}}>Mengetahui data apa yang kami kumpulkan tentang Anda</li>
              <li style={{marginBottom:'0.5rem'}}>Meminta penghapusan data kunjungan Anda</li>
              <li style={{marginBottom:'0.5rem'}}>Menolak penggunaan cookies tertentu</li>
            </ul>
          </section>

          <section style={{marginBottom:'2.5rem'}}>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>7. Perubahan Kebijakan</h2>
            <p>Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan akan dipublikasikan di halaman ini dengan tanggal pembaruan yang tertera di atas.</p>
          </section>

          <section>
            <h2 style={{fontSize:'1.375rem',fontWeight:700,color:'#0f172a',marginBottom:'1rem'}}>8. Hubungi Kami</h2>
            <p>Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami:</p>
            <div style={{backgroundColor:'#ecfdf5',padding:'1.25rem',borderRadius:'0.75rem',marginTop:'1rem',border:'1px solid #d1fae5'}}>
              <p style={{margin:'0 0 0.5rem 0'}}><strong>Lakpesdam PBNU</strong></p>
              <p style={{margin:'0 0 0.25rem 0',fontSize:'0.875rem'}}>Jl. KH. Ramli No. 20A, Menteng Dalam Tebet, Jakarta</p>
              <p style={{margin:'0 0 0.25rem 0',fontSize:'0.875rem'}}>Email: lakpesdam@lakpesdam.or.id</p>
              <p style={{margin:0,fontSize:'0.875rem'}}>Telp: +62 21 829 8855</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
